/* PDP Eclipse — E5. Botón "Comprar ahora" (buy now) + sincronía de estado con la variante. */
/*
  Contexto: la tienda tiene Shop Pay activo, así que Shopify no renderiza el botón unbranded
  pintable. El CTA "Comprar ahora" es un <button data-buy-now> propio (buy-buttons.liquid) que
  agrega la variante al carrito y redirige a /checkout.

  Dos responsabilidades:
  1. Handler de click del buy-now (delegado en document, sobrevive re-render de sección).
  2. Espejo de estado: cuando cambia la variante, Dawn deshabilita SOLO el add-to-cart nativo
     (product-info.js -> toggleSubmitButton, mutación quirúrgica). El buy-now y el "En existencia"
     no se enteran solos -> un MutationObserver espeja el estado del add-to-cart.

  Idempotencia: guard global para no registrar el handler dos veces; WeakSet para no observar el
  mismo botón nativo dos veces.
*/
(function () {
  if (window.__eclipseBuyNowBound) {
    return;
  }
  window.__eclipseBuyNowBound = true;

  /* -------------------------------------------------------------------------
     1. Handler "Comprar ahora"
     ------------------------------------------------------------------------- */
  document.addEventListener('click', function (event) {
    var boton = event.target.closest('[data-buy-now]');
    if (!boton) {
      return;
    }

    event.preventDefault();

    if (boton.hasAttribute('disabled') || boton.getAttribute('aria-disabled') === 'true') {
      return;
    }

    // El <form> real (dentro del <product-form>). Contiene id, quantity, properties[...],
    // selling_plan, y los campos del gift-card recipient si están activos.
    var form = boton.closest('form');
    if (!form) {
      return;
    }

    // Validación nativa: respeta required (ej. email del gift-card recipient) igual que el ATC.
    if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
      form.reportValidity();
      return;
    }

    // FormData desde el form COMPLETO: preserva properties[...] (personalización Kickflip futura,
    // gift-card recipient hoy) y selling_plan. Sin header Content-Type: el browser fija el
    // boundary multipart solo — ponerlo a mano rompería el parseo del cuerpo.
    var body = new FormData(form);

    // Anti doble-click: deshabilita el botón para que un segundo click no dispare otro /cart/add.
    boton.disabled = true;
    boton.setAttribute('aria-busy', 'true');

    fetch('/cart/add.js', { method: 'POST', body: body })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(
            function (data) {
              throw new Error((data && data.description) || ('cart/add falló: ' + response.status));
            },
            function () {
              throw new Error('cart/add falló: ' + response.status);
            }
          );
        }
        return response.json();
      })
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function (error) {
        // Rehabilita para que el usuario pueda reintentar; no redirige.
        boton.disabled = false;
        boton.removeAttribute('aria-busy');
        if (window.console && console.error) {
          console.error('[Eclipse buy-now]', error);
        }
      });
  });

  /* -------------------------------------------------------------------------
     2. Espejo de estado add-to-cart -> buy-now + in-stock (MutationObserver)
     ------------------------------------------------------------------------- */
  /*
    Por qué MutationObserver y no el pubsub de Dawn:
    subscribe/publish/PUB_SUB_EVENTS SÍ son globales accesibles desde script clásico
    (pubsub.js y constants.js se cargan sin type="module"). Aun así, el observer es la vía
    robusta: espeja la ÚNICA fuente de verdad que Dawn ya computó —el atributo `disabled` del
    add-to-cart nativo, que product-info.js fija leyendo el HTML de la variante recién traída
    del servidor (incluye reglas de cantidad, inventory policy, combinación inexistente)—, en
    vez de re-derivar disponibilidad desde el payload de un evento cuya forma/timing podría
    cambiar entre versiones de Dawn. product-info.js muta el mismo nodo del botón in-place
    (referencia cacheada), así que observar sus atributos es fiable.
  */
  var observados = new WeakSet();

  function espejar(atc) {
    var form = atc.closest('form');
    if (!form) {
      return;
    }
    var disabled = atc.hasAttribute('disabled');

    var buyNow = form.querySelector('[data-buy-now]');
    if (buyNow) {
      buyNow.disabled = disabled;
    }

    var instock = form.querySelector('.eclipse-instock');
    if (instock) {
      instock.hidden = disabled;
    }

    // [E5.2] Misma mutación, dos consumidores más: la barra sticky espeja el mismo
    // `disabled` y refresca su precio (ver sección 3 más abajo).
    sincronizarStickyDesdeVariante(atc);
  }

  function conectar(atc) {
    if (observados.has(atc)) {
      return;
    }
    observados.add(atc);

    var observer = new MutationObserver(function () {
      espejar(atc);
    });
    observer.observe(atc, { attributes: true, attributeFilter: ['disabled'] });

    // Sincronía inicial por si la variante pre-seleccionada al cargar ya está agotada.
    espejar(atc);
  }

  function escanear() {
    var botones = document.querySelectorAll('.product-form__submit');
    for (var i = 0; i < botones.length; i++) {
      conectar(botones[i]);
    }
  }

  /* -------------------------------------------------------------------------
     3. Barra sticky de add-to-cart (E5.2)
     ------------------------------------------------------------------------- */
  /*
    3a. Precio + disabled: llamado desde `espejar()` arriba, con el MISMO `atc` que ya
    sincroniza buy-now/in-stock — un solo MutationObserver alimenta los tres consumidores.

    Precio: en vez de reimplementar el filtro `money`, se copia el texto que Dawn ya
    formateó y ya mantiene actualizado en el bloque de precio principal
    (product-info.js -> handleUpdateProductInfo -> updateSourceFromDestination('price'),
    que reemplaza el innerHTML de #price-<sectionId> completo en cada cambio de variante).
    Limitación conocida y aceptada: si `snippets/price.liquid` cambia las clases
    `.price--on-sale` / `.price-item--sale` / `.price-item--regular`, este selector hay que
    actualizarlo a la par (documentado, no oculto).
  */
  function sincronizarStickyDesdeVariante(atc) {
    var barra = document.querySelector('[data-pdp-sticky]');
    if (!barra) {
      return;
    }

    var sectionId = atc.id.replace('ProductSubmitButton-', '');
    if (barra.getAttribute('data-section-id') !== sectionId) {
      return;
    }

    var boton = barra.querySelector('[data-sticky-add]');
    if (boton) {
      boton.disabled = atc.hasAttribute('disabled');
    }

    var priceWrap = document.getElementById('price-' + sectionId);
    if (!priceWrap) {
      return;
    }

    var priceRoot = priceWrap.querySelector('.price');
    var enOferta = !!priceRoot && priceRoot.classList.contains('price--on-sale');
    var precioTexto = null;
    var compareTexto = null;

    if (enOferta) {
      var saleItem = priceWrap.querySelector('.price__sale .price-item--sale');
      var compareItem = priceWrap.querySelector('.price__sale .price-item--regular');
      precioTexto = saleItem && saleItem.textContent.trim();
      compareTexto = compareItem && compareItem.textContent.trim();
    } else {
      var regularItem = priceWrap.querySelector('.price__regular .price-item--regular');
      precioTexto = regularItem && regularItem.textContent.trim();
    }

    var precioSpan = barra.querySelector('[data-sticky-price]');
    var compareSpan = barra.querySelector('[data-sticky-compare]');

    if (precioTexto && precioSpan) {
      precioSpan.textContent = precioTexto;
    }
    if (compareSpan) {
      if (compareTexto) {
        compareSpan.textContent = compareTexto;
        compareSpan.hidden = false;
      } else {
        compareSpan.hidden = true;
      }
    }
  }

  /*
    3b. Aparición por scroll: IntersectionObserver sobre `.product-form__buttons` (el bloque
    de compra principal, contiene el add-to-cart nativo). No se usa GSAP ni listeners de
    scroll a mano — el gotcha documentado en el build plan (§7) es justo ese patrón de
    scroll-jack; IntersectionObserver es la vía nativa y barata.
  */
  var stickyConectada = new WeakSet();
  var precioObservado = new WeakSet();

  function alternarBarraSticky(barra, mostrar) {
    if (mostrar) {
      // El atributo [hidden] solo se quita UNA vez (la primera aparición). De ahí en
      // adelante, la visibilidad la gobierna por completo la clase `is-visible` (ver
      // pdp-eclipse.css) — evita tener que escuchar `transitionend` para poder
      // restaurar [hidden] en cada ocultamiento.
      barra.hidden = false;
      // Un frame de respiro: quitar [hidden] y agregar la clase en el mismo tick haría que
      // el navegador colapse la transición de opacidad/translate (no hay "estado anterior"
      // que animar si display pasa de none a flex y la clase ya está puesta a la vez).
      window.requestAnimationFrame(function () {
        barra.classList.add('is-visible');
      });
    } else {
      barra.classList.remove('is-visible');
    }
  }

  function conectarStickyObserver(bloqueCompra, barra) {
    if (stickyConectada.has(bloqueCompra)) {
      return;
    }
    stickyConectada.add(bloqueCompra);

    var observer = new IntersectionObserver(
      function (entries) {
        var entrada = entries[0];
        alternarBarraSticky(barra, !entrada.isIntersecting);
      },
      { threshold: 0 }
    );
    observer.observe(bloqueCompra);
  }

  /*
    3c. [E5.2 audit MUST-FIX] Re-sync de precio en cambio de variante SIN cambio de
    disponibilidad. El MutationObserver de la sección 2 solo escucha el atributo `disabled` del
    ATC nativo → variante A ($100, en stock) → B ($200, en stock) NO cambia `disabled` y la barra
    se quedaba con el precio viejo. Por eso un segundo observer, sobre el nodo de precio
    #price-<sectionId>, con {childList, subtree}: Dawn (product-info.js) reemplaza su innerHTML
    completo en cada cambio de variante → aquí se re-lee y se copia al sticky.

    Por qué observer sobre el nodo y no PUB_SUB_EVENTS.variantChange: misma filosofía que la
    sección 2 — observar la verdad que Dawn YA computó y pintó (el DOM de precio final, con reglas
    de moneda/oferta ya aplicadas), en vez de re-derivar desde el payload de un evento cuyo
    timing/forma podría cambiar entre versiones de Dawn. Idempotente vía WeakSet(precioObservado).
  */
  function conectarObserverDePrecio(atc, barra) {
    var sectionId = barra.getAttribute('data-section-id');
    var priceWrap = document.getElementById('price-' + sectionId);
    if (!priceWrap || precioObservado.has(priceWrap)) {
      return;
    }
    precioObservado.add(priceWrap);

    var observer = new MutationObserver(function () {
      sincronizarStickyDesdeVariante(atc);
    });
    observer.observe(priceWrap, { childList: true, subtree: true });
  }

  function escanearStickyAtc() {
    var barra = document.querySelector('[data-pdp-sticky]');
    if (!barra) {
      return;
    }
    // [E5.2 audit#2] Marca el <body> para reservar espacio inferior en móvil (CSS) y que la barra
    // fija no tape el footer. Constante (no depende de is-visible) → sin layout-shift al
    // aparecer/desaparecer. Idempotente.
    document.body.classList.add('pdp-sticky-present');

    var sectionId = barra.getAttribute('data-section-id');
    var atc = document.getElementById('ProductSubmitButton-' + sectionId);
    var bloqueCompra = atc && atc.closest('.product-form__buttons');
    if (bloqueCompra) {
      conectarStickyObserver(bloqueCompra, barra);
    }
    if (atc) {
      conectarObserverDePrecio(atc, barra);
    }
  }

  /* -------------------------------------------------------------------------
     4. Botón "Agregar" de la barra sticky (E5.2)
     ------------------------------------------------------------------------- */
  /*
    Agrega al carrito SIN redirigir (a diferencia de buy-now). Reutiliza el mismo <form>
    del bloque de compra principal (id derivado de data-section-id, igual que en
    sincronizarStickyDesdeVariante). Si el cart-drawer de Dawn está en la página (theme
    setting cart_type: "drawer", ver layout/theme.liquid), se piden sus secciones en el
    mismo /cart/add.js y se pinta con SU PROPIO `renderContents` — el mismo método público
    que usa product-form.js para el add-to-cart nativo, sin reimplementar nada del drawer.
  */
  function actualizarContadorCarritoFallback() {
    // TODO E6: fallback solo para cuando NO hay <cart-drawer> en la página (cart_type
    // distinto de "drawer" en el theme settings actual, ver config/settings_data.json).
    // Hoy (cart_type: "drawer") esta rama no se ejecuta; se deja como red mínima si el
    // ajuste cambia en el futuro, sin reimplementar cart-notification.
    fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cartData) {
        var contador = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden]');
        if (contador) {
          contador.textContent = cartData.item_count;
        }
      })
      .catch(function () {});
  }

  // [E5.2 audit#1/#4] Anuncia estado a la región aria-live (lectores de pantalla). No es visual.
  function anunciarSticky(barra, mensaje) {
    if (!barra) {
      return;
    }
    var status = barra.querySelector('[data-sticky-status]');
    if (status) {
      status.textContent = mensaje;
    }
  }

  /*
    [E5.2 audit#5] El botón entra a este estado ya deshabilitado (lo hace el click handler) y se
    MANTIENE deshabilitado durante toda la ventana del check ✓ (1800ms) → un segundo click en esa
    ventana no dispara otro /cart/add. Al expirar, se re-sincroniza desde la variante para
    restaurar el estado correcto (habilitado si hay stock, deshabilitado si la variante se agotó),
    en vez de re-habilitar a ciegas.
  */
  function mostrarCheckSticky(boton, atc) {
    var label = boton.querySelector('[data-sticky-add-label]');
    var check = boton.querySelector('[data-sticky-add-check]');
    if (label) {
      label.hidden = true;
    }
    if (check) {
      check.hidden = false;
    }

    window.clearTimeout(boton.__eclipseStickyCheckTimeout);
    boton.__eclipseStickyCheckTimeout = window.setTimeout(function () {
      if (label) {
        label.hidden = false;
      }
      if (check) {
        check.hidden = true;
      }
      // Restaura el estado disabled real de la variante (no re-habilita a ciegas).
      if (atc) {
        sincronizarStickyDesdeVariante(atc);
      } else {
        boton.disabled = false;
      }
    }, 1800);
  }

  document.addEventListener('click', function (event) {
    var boton = event.target.closest('[data-sticky-add]');
    if (!boton) {
      return;
    }

    if (boton.disabled || boton.getAttribute('aria-disabled') === 'true') {
      return;
    }

    var barra = boton.closest('[data-pdp-sticky]');
    var sectionId = barra && barra.getAttribute('data-section-id');
    var atc = sectionId && document.getElementById('ProductSubmitButton-' + sectionId);
    var form = atc && atc.closest('form');
    if (!form) {
      return;
    }

    if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
      form.reportValidity();
      return;
    }

    var body = new FormData(form);

    var cart = document.querySelector('cart-drawer');
    var pintaConDrawer = !!(cart && typeof cart.getSectionsToRender === 'function' && typeof cart.renderContents === 'function');
    if (pintaConDrawer) {
      body.append(
        'sections',
        cart.getSectionsToRender()
          .map(function (seccion) {
            return seccion.id;
          })
          .join(',')
      );
      body.append('sections_url', window.location.pathname);
    }

    // Deshabilita durante el fetch; en éxito sigue deshabilitado por la ventana del check
    // (audit#5), en error se re-habilita en el catch.
    boton.disabled = true;
    boton.setAttribute('aria-busy', 'true');

    fetch('/cart/add.js', { method: 'POST', body: body })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(
            function (data) {
              // 422 (sold-out / límite de inventario) trae `description` legible de Shopify.
              throw new Error((data && data.description) || ('cart/add falló: ' + response.status));
            },
            function () {
              throw new Error('cart/add falló: ' + response.status);
            }
          );
        }
        return response.json();
      })
      .then(function (data) {
        if (pintaConDrawer) {
          cart.renderContents(data);
        } else {
          actualizarContadorCarritoFallback();
        }
        boton.removeAttribute('aria-busy');
        mostrarCheckSticky(boton, atc);
        anunciarSticky(barra, 'Agregado al carrito');
      })
      .catch(function (error) {
        if (window.console && console.error) {
          console.error('[Eclipse sticky-atc]', error);
        }
        // [E5.2 audit#4] Feedback discreto en error (ej. 422 agotado). Se re-habilita el botón
        // para que el usuario pueda reintentar; el mensaje va a la región live.
        boton.disabled = false;
        boton.removeAttribute('aria-busy');
        anunciarSticky(barra, (error && error.message) || 'No disponible');
      });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', escanear);
    document.addEventListener('DOMContentLoaded', escanearStickyAtc);
  } else {
    escanear();
    escanearStickyAtc();
  }

  // Re-escanea si el theme editor recarga la sección (nuevos nodos de botón / barra sticky).
  document.addEventListener('shopify:section:load', escanear);
  document.addEventListener('shopify:section:load', escanearStickyAtc);
})();
